import React from 'react';
import { Link } from 'react-router-dom';
import { Compass, Home, LayoutGrid, Ticket } from 'lucide-react';

export function NotFoundPage() {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4 py-16">
      <div className="w-16 h-16 rounded-3xl bg-[#0A3D27]/10 border border-[#0A3D27]/20 flex items-center justify-center mb-6 text-[#0A3D27]">
        <Compass className="w-8 h-8" />
      </div>
      <span className="text-xs font-extrabold tracking-widest uppercase text-[#785613] bg-[#FAF5EA] border border-[#E6C687] px-3 py-1 rounded-full mb-3">
        404 Error
      </span>
      <h1 className="text-4xl sm:text-5xl font-black text-slate-900 tracking-tight mb-4">
        Page Not Found
      </h1>
      <p className="text-sm text-slate-600 max-w-md mb-8">
        The page you are looking for does not exist or has been relocated within the IIAB 2027 platform.
      </p>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="flex items-center gap-2 px-5 py-2.5 bg-[#0A3D27] hover:bg-[#062B1B] text-white font-extrabold rounded-xl text-xs transition-all shadow-md shadow-[#0A3D27]/20 cursor-pointer"
        >
          <Home className="w-4 h-4" />
          <span>Return Home</span>
        </Link>
        <Link
          to="/floorplan"
          className="flex items-center gap-2 px-5 py-2.5 bg-white hover:bg-slate-50 text-slate-700 border border-slate-300 rounded-xl text-xs font-bold transition-all shadow-xs cursor-pointer"
        >
          <LayoutGrid className="w-4 h-4 text-[#0A3D27]" />
          <span>Exhibition Floor Plan</span>
        </Link>
        <Link
          to="/register"
          className="flex items-center gap-2 px-5 py-2.5 bg-white hover:bg-slate-50 text-slate-700 border border-slate-300 rounded-xl text-xs font-bold transition-all shadow-xs cursor-pointer"
        >
          <Ticket className="w-4 h-4 text-[#0A3D27]" />
          <span>Register to Attend</span>
        </Link>
      </div>
    </div>
  );
}

export default NotFoundPage;
